import { DisconnectOutlined, LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import useNotification from 'antd/es/notification/useNotification';
import { useAuth } from 'auth/AuthContext';
import AuthContainer from 'components/containers/AuthContainer';
import posthog from 'posthog-js';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from 'services/RouteService';
import { Button } from 'components/ui';
import { colors } from 'design';

const useStyles = createUseStyles({
  connectionErrorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 64,
    gap: 12,
  },
  connectionError: {
    color: colors.dataViz.bad,
    textAlign: 'center',
    marginTop: 12,
  },
});

export default function WelcomePage() {
  // Hooks
  const { status, tryToLoginFromStoredTokens } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [, context] = useNotification();
  const styles = useStyles();

  return (
    <>
      {context}

      <AuthContainer
        title={t('loginRegister.welcome.title')}
        description={t('loginRegister.welcome.description')}
        mode="login"
        bottomLinkTo="none"
        displayLogo
      >
        {status === 'loading' ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Spin indicator={<LoadingOutlined spin />} size="large" />
          </div>
        ) : (
          <>
            <Button
              variant="primary"
              block
              size="lg"
              onClick={() => navigate(routes.login.route, { state: location.state })}
            >
              {t('loginRegister.actions.login')}
            </Button>
            <Button
              variant="link"
              style={{ marginTop: 12 }}
              block
              size="lg"
              onClick={() => navigate(routes.register.route)}
            >
              {t('loginRegister.actions.register')}
            </Button>
          </>
        )}
        {status === 'error' && (
          <div className={styles.connectionErrorContainer}>
            <DisconnectOutlined style={{ fontSize: 32, color: colors.dataViz.bad }} />
            <p className={styles.connectionError}>{t('loginRegister.errors.errorOccurred')}</p>
            <Button
              variant="primary"
              size="lg"
              onClick={() => {
                tryToLoginFromStoredTokens();
                posthog.capture('login.retry_on_error');
              }}
            >
              {t('loginRegister.actions.retry')}
            </Button>
          </div>
        )}
      </AuthContainer>
    </>
  );
}
